export default "__VITE_ASSET__439db10d__"